import React, { useMemo, useState } from "react";
import Select from "../../features/ARR/components/shared/Select";
import { URL } from "../../utils/Constants";
import { axiosPost } from "../../utils/AxiosApi";
import swal from "sweetalert";
import { Spinner } from "reactstrap";

const PromoteStudentsModal = ({
  studentsData,
  setPromoteModal,
  classroom,
  getAllStudents,
}) => {
  const [promoteData, setPromoteData] = useState({
    yearLevelId: "",
    classroomId: "",
  });
  const [loading, setLoading] = useState(false);

  const selectedStudents = useMemo(() => {
    if (!studentsData?.length) return [];

    return studentsData?.filter((item) => item?.checked);
  }, [studentsData]);

  const yearLevel = useMemo(() => {
    if (classroom?.length === 0) return [];

    return classroom?.map((item) => ({
      label: item.yearLevelName,
      value: item.yearLevelId,
    }));
  }, [classroom]);

  //remove duplicate classlevel
  const yearLevelOptions = useMemo(() => {
    const obj = new Set();

    return yearLevel?.filter((item) => {
      if (obj.has(item.value)) return false;

      obj.add(item.value);
      return true;
    });
  }, [yearLevel]);

  const classroomOptions = useMemo(() => {
    if (classroom?.length === 0) return [];

    return classroom?.reduce((acc, arr) => {
      if (arr?.yearLevelId === Number(promoteData?.yearLevelId)) {
        acc.push({ label: arr.name, value: arr.id });
      }
      return acc;
    }, []);
  }, [classroom, promoteData?.yearLevelId]);

  const promoteStudentsApi = (params) => {
    return new Promise((resolve, reject) => {
      axiosPost(
        URL.reAssignStudenttoClassroom,
        params,
        (response) => {
          if (response?.status === 200) {
            resolve(response);
            swal(
              "Success",
              response?.data?.message ??
                `Successfully reassigned student${selectedStudents?.length > 1 ? "s" : ""}`,
            );
          } else {
            reject(response);
          }
        },
        (error) => {
          swal(
            "Oops",
            `Failed to reassign student${selectedStudents?.length > 1 ? "s" : ""}`,
          );

          reject(error);
        },
      );
    });
  };

  const handlePromoteStudents = async () => {
    if (!selectedStudents?.length) {
      swal("Oops", "Please select at least one student");
      return;
    }

    if (!promoteData.yearLevelId) {
      swal("OOps", "Please select a class");
      return;
    }

    if (!promoteData.classroomId) {
      swal("OOps", "Please select a section");
      return;
    }

    const admissions = selectedStudents?.map((item) => ({
      id: item?.admissionId,
    }));

    const newClassroom = {
      id: promoteData.classroomId,
      yearLevelId: promoteData.yearLevelId,
    };

    const params = {
      admissions,
      newClassroom,
    };

    setLoading(true);
    try {
      await promoteStudentsApi(params);
      getAllStudents();
      setPromoteModal(false);
    } catch (error) {
      console.error("Failed to promote", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div
        style={{ width: "100%", padding: 0, margin: "16px 0 0 0" }}
        className="form-input"
      >
        <label style={{ marginBottom: "12px" }} htmlFor="">
          Class
        </label>
        <Select
          options={yearLevelOptions}
          value={
            yearLevelOptions?.find(
              (opt) => opt?.value === promoteData.yearLevelId,
            ) || null
          }
          onChange={(opt) => {
            setPromoteData({
              yearLevelId: opt?.value,
              classroomId: "",
            });
          }}
        />
      </div>

      <div
        style={{ width: "100%", padding: 0, margin: "16px 0 0 0" }}
        className="form-input"
      >
        <label style={{ marginBottom: "12px" }} htmlFor="">
          Section
        </label>
        <Select
          options={classroomOptions}
          value={
            classroomOptions?.find(
              (opt) => opt?.value === promoteData.classroomId,
            ) || null
          }
          onChange={(opt) =>
            setPromoteData((prev) => ({ ...prev, classroomId: opt?.value }))
          }
        />
      </div>

      <p className="arr-note">
        <strong>Note: </strong>Please select the class and section to which you
        would like to promote the students.
      </p>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          justifyContent: "end",
        }}
      >
        <button
          onClick={() => {
            setPromoteModal(false);
            setPromoteData({ yearLevelId: "", classroomId: "" });
          }}
          style={{ padding: "8px 16px" }}
          className="secondary-btn"
        >
          Cancel
        </button>
        <button
          onClick={handlePromoteStudents}
          disabled={loading}
          style={{ padding: "8px 16px" }}
          className="primary-btn"
        >
          {loading ? <Spinner size={"sm"} color="white" /> : "Promote"}
        </button>
      </div>
    </>
  );
};

export default PromoteStudentsModal;
